import { render, staticRenderFns } from "./entityConfig.vue?vue&type=template&id=5f06f389&scoped=true"
import script from "./entityConfig.vue?vue&type=script&lang=js"
export * from "./entityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06f389",
  null
  
)

export default component.exports